import * as React from 'react';
import { SiteRoute } from '@journeyapps/package-types';
import { Route, Routes } from 'react-router';
import { BlogPage } from './pages/blog/BlogPage';
import { DocsPage } from './pages/docs/DocsPage';
import { CustomersPage } from './pages/CustomersPage';
import { HomePage } from './pages/HomePage';
import { AIPage } from './pages/AIPage';
import { AIManifesto } from './pages/legal/AIManifesto';
import { DisclaimerPage } from './pages/legal/DisclaimerPage';
import { GDPRPage } from './pages/legal/GDPRPage';
import { PrivacyPolicyPage } from './pages/legal/PrivacyPolicyPage';
import { SecurityReportingPage } from './pages/legal/SecurityReportingPage';
import { TermsPage } from './pages/legal/TermsPage';
import { FAQPage } from './pages/overview/FAQPage';
import { FeaturesPage } from './pages/overview/features/FeaturesPage';
import { FeatureFinderPage } from './pages/overview/features/FeatureFinderPage';
import { RapidCodePage } from './pages/overview/RapidCodePage';
import { RoadmapPage } from './pages/roadmap/RoadmapPage';
import { PricingPage } from './pages/pricing/PricingPage';
import { OxidePage } from './pages/stack/OxidePage';
import { SectorPage } from './pages/stack/SectorPage';
import { OverridePage } from './pages/stack/OverridePage';
import { RuntimeEnginePage } from './pages/stack/RuntimeEnginePage';
import { AppBackendPage } from './pages/stack/AppBackendPage';
import { CloudCodePage } from './pages/stack/CloudCodePage';
import { OpSQLPage } from './pages/stack/OpSQLPage';
import { SubProcessorsPage } from './pages/legal/SubProcessorsPage';
import { NotFoundPage } from './pages/NotFoundPage';

export enum ExternalLinks {
  GET_STARTED_PROD = 'https://accounts.journeyapps.com/portal/get-started',
  GET_STARTED_STAGING = 'https://accounts.staging.journeyapps.com/portal/get-started',

  SIGN_IN_PROD = 'https://accounts.journeyapps.com/portal',
  SIGN_IN_STAGING = 'https://accounts.staging.journeyapps.com/portal',

  POWERSYNC = 'https://powersync.com',
  DISCORD = 'https://devs.journeyapps.com',
  DOCS_RESPONSIVE_APPS = '/docs/get-started/tutorial-build-your-first-app/advanced-topics/layouts-styling-and-lists/responsive-layouts',
  CONTACT_US = 'https://journeyapps.com/contact/'
}

export const getSignInLink = () => {
  if (window.location.host.includes('.staging')) {
    return ExternalLinks.SIGN_IN_STAGING;
  }
  if (window.location.host === 'localhost:9000') {
    return ExternalLinks.SIGN_IN_STAGING;
  }
  return ExternalLinks.SIGN_IN_PROD;
};

export const getGettingStartedLink = () => {
  if (window.location.host.includes('.staging')) {
    return ExternalLinks.GET_STARTED_STAGING;
  }
  if (window.location.host === 'localhost:9000') {
    return ExternalLinks.GET_STARTED_STAGING;
  }
  return ExternalLinks.GET_STARTED_PROD;
};

export enum Documents {
  OPSQL = '/public/documents/JourneyApps-Brochure-SQL-Data-Pipelines.pdf',
  SECURITY = '/public/documents/JourneyApps-White-Paper-Data-Security.pdf',
  GDPR_DPA = '/public/documents/JourneyApps-GDPR-DPA-Data-Processing-Addendum-2026-01-28.pdf'
}

export const RoutesWidget: React.FC = () => {
  return (
    <Routes>
      <Route path={SiteRoute.HOMEPAGE} element={<HomePage />} />
      <Route path={SiteRoute.AI} element={<AIPage />} />
      <Route path={`${SiteRoute.BLOG}*`} element={<BlogPage />} />
      <Route path={`${SiteRoute.DOCS}*`} element={<DocsPage />} />
      <Route path={SiteRoute.SECTOR} element={<SectorPage />} />
      <Route path={SiteRoute.OXIDE} element={<OxidePage />} />
      <Route path={SiteRoute.TERMS_OF_USE} element={<TermsPage />} />
      <Route path={SiteRoute.PRIVACY_POLICY} element={<PrivacyPolicyPage />} />
      <Route path={SiteRoute.DISCLAIMER} element={<DisclaimerPage />} />
      <Route path={SiteRoute.GDPR} element={<GDPRPage />} />
      <Route path={SiteRoute.SECURITY_REPORTING} element={<SecurityReportingPage />} />
      <Route path={SiteRoute.AI_MANIFESTO} element={<AIManifesto />} />
      <Route path={SiteRoute.CUSTOMERS} element={<CustomersPage />} />
      <Route path={SiteRoute.FAQ} element={<FAQPage />} />
      <Route path={SiteRoute.FEATURES} element={<FeaturesPage />} />
      <Route path={SiteRoute.FEATURE_FINDER} element={<FeatureFinderPage />} />
      <Route path={SiteRoute.RAPID_CODE} element={<RapidCodePage />} />
      <Route path={SiteRoute.ROADMAP} element={<RoadmapPage />} />
      <Route path={SiteRoute.PRICING} element={<PricingPage />} />
      <Route path={SiteRoute.RUNTIME_ENGINE} element={<RuntimeEnginePage />} />
      <Route path={SiteRoute.APP_BACKEND} element={<AppBackendPage />} />
      <Route path={SiteRoute.OVERRIDE} element={<OverridePage />} />
      <Route path={SiteRoute.CLOUD_CODE} element={<CloudCodePage />} />
      <Route path={SiteRoute.OPSQL} element={<OpSQLPage />} />
      <Route path={SiteRoute.SUB_PROCESSORS} element={<SubProcessorsPage />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
};
